import { render, staticRenderFns } from "./ProzesskostenrechnerPage.vue?vue&type=template&id=21ae0c74&"
import script from "./ProzesskostenrechnerPage.vue?vue&type=script&lang=js&"
export * from "./ProzesskostenrechnerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports